import { TableCell, TableHead, TableRow } from '@mui/material';
import { type FC } from 'react';
import { PhysicianDTO } from 'src/services/apiServices/physician-service/physician-service';
import { HeaderContent } from './HeaderContent';
import { physicianTableHeaders } from '../table-heads';
import { OptionType, SortOptions } from '../types/SortOptions';

type TableHeaderProps = {
  physicianDto: PhysicianDTO;
  setPhysicianDto: (physicianDto: PhysicianDTO) => void;
  onSort?: (sortOption: SortOptions) => void;
  getAllFacilityList: (label: any) => OptionType[];
  getAllPatient: (label: any) => OptionType[];
  getTheDates: (startDate: any, endDate: any) => { startDate: any; endDate: any };
  handleCallNextApi: (label: any, searchValue: any, isFromSearch: any) => void;
  handleCallTheList: (label: any) => void;
  handleSortMultiselect: (label: any, direction: any) => void;
  selectedDueDate: any;
  setSelectedDueDate: (date: any) => void;
  facilitiesCount: number,
  patientsCount: number,
};

export const DocumentTableHeader: FC<TableHeaderProps> = ({
  physicianDto,
  setPhysicianDto,
  onSort,
  getAllFacilityList,
  getAllPatient,
  getTheDates,
  handleCallNextApi,
  handleCallTheList,
  handleSortMultiselect,
  selectedDueDate,
  setSelectedDueDate,
  facilitiesCount,
  patientsCount,
  ...filterProps
}) => (
  <TableHead>
    <TableRow>
      {physicianTableHeaders?.map((item, index) => (
        <TableCell key={index}>
          <HeaderContent
            physicianDto={physicianDto}
            setPhysicianDto={setPhysicianDto}
            item={item}
            onSort={onSort}
            getAllFacilityList={getAllFacilityList}
            getAllPatient={getAllPatient}
            getTheDates={getTheDates}
            handleCallNextApi={handleCallNextApi}
            handleCallTheList={handleCallTheList}
            handleSortMultiselect={handleSortMultiselect}
            selectedDueDate={selectedDueDate}
            setSelectedDueDate={setSelectedDueDate}
            facilitiesCount={facilitiesCount}
            patientsCount={patientsCount}
            {...filterProps}
          />
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);
